<div class="flex flex-col w-full min-h-full items-center justify-center">
    <div class="w-full text-center text-3xl text-pet-color-text-2 font-bold">
        Detalle Cita Asignada
    </div>
    <div class="text-center text-pet-color-text-4 mt-7 w-[55%]">
        ¡La cita veterinaria ha sido programada con éxito! <br><br>
        Para confirmar la cita, por favor digale al paciente que confirme la cita dando clic en el boton <strong>'Confirmar'</strong> 
        desde la sección de gestión de citas en su cuenta. Si necesita cancelar la cita, también puede hacerlo desde cuenta.
    </div>
    <div class="flex flex-col border-2 border-pet-color-text-2 w-[55%] mt-7 p-4 rounded-xl">
        <div class="w-full text-pet-color-text-2 text-center font-bold">
            Detalle de la consulta
        </div>
        <div class="flex w-full px-10 py-6">
            <div class="flex flex-1 flex-col w-full gap-1">
                <div class="flex w-full">
                    <div class="text-pet-color-text-5 font-semibold">Fecha:</div>
                    <div class="text-pet-color-text-6 ml-2 font-semibold">{{consulta.consultaFechaCita}}</div></div>
                <div class="flex w-full">
                    <div class="text-pet-color-text-5 font-semibold">Peludito:</div>
                    <div class="text-pet-color-text-6 ml-2">{{consulta.consultaIdMascota}}</div></div>
                <div class="flex w-full">
                    <div class="text-pet-color-text-5 font-semibold">Valor de la Consulta:</div>
                    <div class="text-pet-color-text-6 ml-2 font-semibold">{{consulta.valorConsulta}}</div></div>
                <div class="flex w-full">
                    <div class="text-pet-color-text-5 font-semibold">Asignado por:</div>
                    <div class="text-pet-color-text-6 ml-2 font-semibold">{{consulta.usuarioSuscriptorNombre}}</div></div>
            </div>
            <div class="flex flex-1 flex-col w-full gap-1">
                <div class="flex w-full">
                    <div class="text-pet-color-text-5 font-semibold flex">Hora:</div>
                    <div class="text-pet-color-text-6 ml-2 font-semibold">{{consulta.consultaHoraCita}}</div></div>
                <div class="flex w-full">
                    <div class="text-pet-color-text-5 font-semibold flex">Tipo de Consulta:</div>
                    <div class="text-pet-color-text-6 ml-2 font-semibold">{{consulta.consultaIdAtencion}}</div></div>
                <div class="flex w-full">
                    <div class="text-pet-color-text-5 font-semibold flex">Suscripción:</div>
                    <div class="text-pet-color-text-6 ml-2 font-semibold">{{consulta.consultaIdUsuario}}</div></div>
                <div class="flex w-full">
                    <div class="text-pet-color-text-5 font-semibold flex">Código de reserva:</div>
                    <div class="text-pet-color-text-6 ml-2 font-semibold">{{consulta.codigo}}</div></div>
            </div>
        </div>
    </div>
    <div class="flex justify-end w-[55%] mt-7">
        <button class="bg-pet-color-3 mr-4 shadow-md shadow-slate-500 hover:bg-pet-color-3-1 text-white font-bold py-2 px-5 rounded-full flex items-center gap-2" [routerLink]="['/vets/scheduled-appointments']">
            Ver Citas Programadas
        </button>
    </div>
</div>